exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -ms-appearance: none;\n  appearance: none;\n  outline: 0;\n  box-shadow: none;\n  border: 0 !important;\n  /*/background: #2c3e50;*/\n  background: #E5E6E7;\n  background-image: none;\n  width: 100%;\n}\n/* Custom Select */\n.select {\n    width: 100%;\n  position: relative;\n  display: block;\n  /*width: 20em;*/\n  height: 3em;\n  line-height: 3;\n  /*/background: #2c3e50;*/\n  background: #E5E6E7;\n  overflow: hidden;\n  border-radius: .25em;\n}\nselect {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0 0 0 .5em;\n  /*color: #fff;*/\n  color:#202735;\n  cursor: pointer;\n}\nselect::-ms-expand {\n  display: none;\n}\n/* Arrow */\n.select::after {\n  content: '\\25BC';\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  padding: 0 1em;\n  /*background: #34495e;*/  \n  background: #202735;\n  color: #FFFFFF;\n  pointer-events: none;\n}\n/* Transition */\n.select:hover::after {\n  color: #f39c12;\n}\n.select::after {\n  transition: .25s all ease;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/select/select.component.css
// module id = ../../../../../src/app/select/select.component.css
// module chunks = main